import script from "./CopyButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CopyButton.vue?vue&type=script&lang=ts&setup=true"

import "./CopyButton.vue?vue&type=style&index=0&id=6f3267ca&lang=scss&scoped=true"
import "./CopyButton.vue?vue&type=style&index=1&id=6f3267ca&lang=scss"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f3267ca"]])

export default __exports__